import Icon from '../components/Icon.vue'

Icon.register({
  dizzy: {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM152 214.6L123.3 243.3C108.5 258.1 85.5 235.8 100.7 220.7L129.4 192 100.7 163.3C85.7 148.3 108.4 125.7 123.3 140.7L152 169.4 180.7 140.7C195.7 125.7 218.3 148.4 203.3 163.3L174.6 192 203.3 220.7C218.5 235.9 195.4 258.1 180.7 243.3L152 214.6zM248 416C212.7 416 184 387.3 184 352S212.7 288 248 288 312 316.7 312 352 283.3 416 248 416zM395.3 220.7C410.5 235.9 387.4 258.1 372.7 243.3L344 214.6 315.3 243.3C300.5 258.1 277.5 235.8 292.7 220.7L321.4 192 292.7 163.3C277.7 148.3 300.4 125.7 315.3 140.7L344 169.4 372.7 140.7C387.7 125.7 410.3 148.4 395.3 163.3L366.6 192 395.3 220.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/dizzy.js
// module id = HhEA
// module chunks = 144